import Pusher, { Channel, Pusher as PusherType } from 'pusher-js'
import config from '../config'
import { getJwt } from './jwtLocalstorage'

// PUSHER CHANNEL EVENTS
export const CHANNEL_CONNECTED_EVENT = 'pusher:subscription_succeeded'
export const CHANNEL_UPLOAD_PAPER_EVENT = 'uploadPaper'
export const CHANNEL_ERROR_EVENT = 'pusher:subscription_error'

// PUSHER GLOBAL EVENTS
export const PUSHER_STATE_CHANGE_EVENT = 'state_change'
export const PUSHER_CONNECTED_EVENT = 'connected'
export const PUSHER_STATE_DISCONNECTED = 'disconnected'
export const PUSHER_STATE_UNAVAILABLE = 'unavailable'

export class PusherClient {
  public pusher?: PusherType

  public uploadChannel?: Channel

  public initialize = (apiKey: string, cluster: string, onConnect: () => void, onDisconnect: () => {}) => {
    const WTAI_EXPRESS_URL = config.getWtaiExpressUrl()
    return new Promise(resolve => {
      this.pusher = new Pusher(apiKey, {
        authEndpoint: `${WTAI_EXPRESS_URL}/auth`,
        auth: {
          headers: {
            'Cache-Control': 'no-store',
            Authorization: `Bearer ${getJwt()}`,
          },
        },
        cluster,
      })

      if (this.pusher) {
        this.pusher.connection.bind(PUSHER_STATE_CHANGE_EVENT, (state: any) => {
          if (state === PUSHER_STATE_DISCONNECTED || state === PUSHER_STATE_UNAVAILABLE) {
            onDisconnect()
          }
        })

        this.pusher.connection.bind(PUSHER_CONNECTED_EVENT, () => {
          onConnect()
          resolve()
        })
      }
    })
  }

  public subscribe = (channelName: string) => {
    return new Promise((resolve, reject) => {
      if (this.pusher) {
        this.uploadChannel = this.pusher.subscribe(channelName)

        this.uploadChannel.bind(CHANNEL_CONNECTED_EVENT, () => {
          resolve()
        })
      }
    })
  }
}

export default PusherClient
